import "react-toggle/style.css";
import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import FieldText from "../Fields/FieldText";
import AlertComponent from "../AlertComponent";

function AddOrEditYoutubeOutput(props) {
  const { outputName, handleAddNewElementsOutput, currentElement } = props;

  const [destinationUrl, setDestinationUrl] = useState(null);
  const [streamingKey, setStreamingKey] = useState(null);

  const handleAddItem = () => {
    if (!outputName) {
      return AlertComponent("Error", "Output name is required", {
        icon: `error`,
      });
    }

    if (!destinationUrl) {
      return AlertComponent("Error", "Destination URL is required", {
        icon: `error`,
      });
    }

    if (!streamingKey) {
      return AlertComponent("Error", "Streaming Key is required", {
        icon: `error`,
      });
    }

    const item = {
      name: outputName,
      outputType: `YouTube`,
      destinationUrl: destinationUrl,
      streamingKey: streamingKey,
    };

    if (currentElement) {
      item.id = currentElement.id;
    }

    handleAddNewElementsOutput(item);
  };

  useEffect(() => {
    if (currentElement) {
      setDestinationUrl(currentElement.destinationUrl);
      setStreamingKey(currentElement.streamingKey);
    }
  }, [currentElement]);

  return (
    <div>
      <FieldText
        label="Destination URL"
        type="text"
        onChange={(x) => setDestinationUrl(x.target.value)}
        placeholder="e.g: a.rtmp.youtube.com"
        value={destinationUrl}
        className="col-md-12"
        required={true}
        inputClassName={`inputOption`}
      />

      <FieldText
        label="Streaming Key / Stream Name"
        type="text"
        onChange={(x) => setStreamingKey(x.target.value)}
        placeholder="e.g: r0r0r-j88j-fu0g-1234"
        value={streamingKey}
        className="col-md-12"
        required={true}
        inputClassName={`inputOption`}
      />

      <Button className="dark-btn" onClick={handleAddItem}>
        {currentElement ? "Edit" : "Add"}
      </Button>
    </div>
  );
}

export default AddOrEditYoutubeOutput;
